import React, {useState} from 'react'

const ReactFAQItem = ({id, topic, answerHtml, searchKeywords, headlineLevel, moduleId, index}) => {
    const [open, setOpen] = useState(false)

    const HType = `h${headlineLevel}`;
	let topicHighlighted = topic,
		answerHtmlHighlighted = answerHtml;

	if(searchKeywords.length && searchKeywords[0] !== '') {
		searchKeywords.forEach((searchString) => {
			const regEx = new RegExp(`${searchString}`, 'gi'),
				htmlRegEx = new RegExp(`${searchString}(?=[^>]*<)`, 'gi');

				topicHighlighted = topicHighlighted && topicHighlighted.replace(regEx, markSearchString);
				answerHtmlHighlighted = answerHtmlHighlighted && answerHtmlHighlighted.replace(htmlRegEx, markSearchString);
		});
	}

    function markSearchString(str) {
        return `<mark>${str}</mark>`
    }

    return (
        <li className={`m-react-faq__item ${open ? '--open' : ''}`}>
			<details id={id}>
				<summary className="m-react-faq__item-header" id={`${moduleId}-${index}`} onClick={() => setOpen(!open)}>
					<HType className="m-react-faq__item-headline">
						<span dangerouslySetInnerHTML={{__html: topicHighlighted}}/>
					</HType>
				</summary>
				<div className="m-react-faq__item-inner">
					{answerHtml && (
						<div className="m-react-faq__item-answer" dangerouslySetInnerHTML={{__html: answerHtmlHighlighted}}/>
					)}
				</div>
			</details>
        </li>
    )
}

export default ReactFAQItem
